import { Vector3 } from 'three';
import Experience from './Experience.js';

const _ndc = new Vector3();

/**
 * The cursor as a world-space ray, recomputed every frame.
 *
 * The shape fields and the particles all want the same question answered - "how
 * close is this thing to the cursor?" - and they live at wildly different
 * depths, from the central cluster a few units out to the orbit field at 80.
 * A ray answers it in a way a single depth plane can't: perpendicular distance
 * to the ray is exactly "how far from the cursor on screen", whatever the
 * depth, so one set of numbers works for every field.
 *
 * Touch is ignored. A finger drag is already the orbit control's gesture, and
 * there is no hover to speak of, so pushing shapes around on a drag would only
 * fight the camera.
 */
export default class Pointer {
    constructor() {
        this.experience = new Experience();
        this.sizes = this.experience.sizes;
        this.camera = this.experience.camera.instance;

        // Normalised device coords, -1..1 with y up.
        this.x = 0;
        this.y = 0;
        // No push until the cursor has actually been somewhere on the canvas.
        this.active = false;

        this.origin = new Vector3();
        this.direction = new Vector3(0, 0, -1);

        window.addEventListener('pointermove', (event) => {
            if (event.pointerType === 'touch') return;
            this.x = (event.clientX / this.sizes.width) * 2 - 1;
            this.y = -(event.clientY / this.sizes.height) * 2 + 1;
            this.active = true;
        });

        // Cursor gone from the page - let everything settle back.
        window.addEventListener('pointerleave', () => { this.active = false; });
        window.addEventListener('blur', () => { this.active = false; });
    }

    update() {
        if (!this.active) return;

        this.origin.copy(this.camera.position);
        _ndc.set(this.x, this.y, 0.5).unproject(this.camera);
        this.direction.copy(_ndc).sub(this.origin).normalize();
    }
}
